import React, { useState } from "react";
import { Accordion, ListGroup } from "react-bootstrap";
import { useAppDispatch } from "../../app/hooks";
import { getOrderHistory } from "../../app/services/orderService";
import { OrderHistory } from "../../models/responses/orderHistory";
import moment from "moment";
import "moment/locale/sv";

interface OrderHistoryAccordionProps {
  orderHistory: OrderHistory[] | null | undefined;
  orderId: string | undefined;
  instance: any;
  account: any;
}

const OrderHistoryAccordion: React.FC<OrderHistoryAccordionProps> = ({
  orderHistory,
  orderId,
  instance,
  account,
}) => {
  const dispatch = useAppDispatch();
  const [historyLoaded, setHistoryLoaded] = useState(false);

  const handleHistoryAccordion = async () => {
    if (!historyLoaded && orderId) {
      dispatch(getOrderHistory(instance, account, orderId));
      setHistoryLoaded(true);
    }
  };

  return (
    <div className="mt-3">
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header onClick={handleHistoryAccordion}>
            Historik
          </Accordion.Header>
          <Accordion.Body>
            <ListGroup as="ul">
              {orderHistory?.map((history) => (
                <ListGroup.Item as="li" key={history.id}>
                  {(() => {
                    switch (history.action.toLowerCase()) {
                      case "add":
                        return <span>Skapades av </span>;
                      case "update":
                        return <span>Uppdaterades av </span>;
                      case "assign":
                        return <span>Låstes av </span>;
                      case "unassign":
                        return <span>Låstes upp av </span>;
                      case "export":
                        return <span>Exportades av </span>;
                      case "revertexport":
                        return <span>Export återställdes av </span>;
                      case "import":
                        return <span>IO/FO hämtad av </span>;
                      default:
                        return <span>-</span>;
                    }
                  })()}
                  <span>{history.userName} </span>
                  <span>
                    {" "}
                    den{" "}
                    {moment
                      .utc(history.createdAt)
                      .local()
                      .format("yyyy-MM-DD")}
                  </span>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default OrderHistoryAccordion;
